import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { Button } from './ui/button';

const AudioPlayer = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    // Check user's music preference
    const musicEnabled = localStorage.getItem('music_enabled');
    const shouldPlay = musicEnabled === null || musicEnabled === 'true';
    
    if (audioRef.current) {
      audioRef.current.volume = 0.3; // Set volume to 30%
      
      if (shouldPlay) {
        // Try to autoplay
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              setIsPlaying(true);
            })
            .catch((error) => {
              // Autoplay was prevented
              console.log('Autoplay prevented:', error);
              setIsPlaying(false);
            });
        }
      } else {
        setIsPlaying(false);
      }
    }

    // Listen for music toggle events
    const handleMusicToggle = (event) => {
      if (audioRef.current) {
        if (event.detail.enabled) {
          audioRef.current.play().then(() => {
            setIsPlaying(true);
          }).catch(console.error);
        } else {
          audioRef.current.pause();
          setIsPlaying(false);
        }
      }
    };

    window.addEventListener('musicToggle', handleMusicToggle);
    return () => {
      window.removeEventListener('musicToggle', handleMusicToggle);
    };
  }, []);

  const toggleMusic = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
        localStorage.setItem('music_enabled', 'false');
      } else {
        audioRef.current.play().then(() => {
          setIsPlaying(true);
          localStorage.setItem('music_enabled', 'true');
        }).catch(console.error);
      }
    }
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <>
      <audio
        ref={audioRef}
        loop
        preload="auto"
        src="https://customer-assets.emergentagent.com/job_holygame/artifacts/tppl1igr_Mega%20Church%20Background%20Music%202023.mp3"
      />
      
      {/* Floating Music Control */}
      <div className="fixed bottom-4 right-4 z-50 flex gap-2">
        <Button
          onClick={toggleMusic}
          variant="outline"
          size="icon"
          className="h-12 w-12 rounded-full bg-white/90 backdrop-blur-md shadow-lg hover:bg-white border-2 border-[#4169E1]"
          title={isPlaying ? 'Pause Music' : 'Play Music'}
        >
          {isPlaying ? (
            <Volume2 className="h-5 w-5 text-[#4169E1]" />
          ) : (
            <VolumeX className="h-5 w-5 text-gray-500" />
          )}
        </Button>
      </div>
    </>
  );
};

export default AudioPlayer;
